/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */

import initGlow from './ShapeEditors';
import setupGui from './setupGui';

import * as BE from '@sick-davinci/basic-elements';
const PRESERVE = [BE]; // do not remove this dependency as optimization build step!

window.addEventListener('WebComponentsReady', async () => {
  setupGui(initGlow(document.getElementById('viewer')));
  document.getElementById('gui').style.display = 'block';
});
